import { tv } from 'tailwind-variants'

export const switchVariants = tv({
  slots: {
    root: [
      // Button reset (Base UI renders Root as <button>)
      'appearance-none m-0 bg-transparent',
      'group/switch relative inline-flex items-center cursor-pointer',
      'rounded-full border-[1.5px] border-solid box-border',
      'transition-colors duration-150',

      'data-[unchecked]:border-components-switch-slideFill',
      'data-[unchecked]:hover:bg-text-hover',

      'data-[disabled]:cursor-not-allowed data-[disabled]:pointer-events-none',
      'data-[disabled]:!border-components-switch-knobFillDisabled',

      'focus-visible:outline-none',
      'data-[focus-visible]:outline data-[focus-visible]:outline-2 data-[focus-visible]:outline-offset-2 data-[focus-visible]:outline-primary-main',
    ],
    thumb: [
      'relative block overflow-hidden rounded-full shadow-1 pointer-events-none',
      'transition-transform duration-150',

      'data-[unchecked]:bg-components-switch-knobFillEnabled',
      'data-[disabled]:!bg-components-switch-knobFillDisabled',

      // Hover ring pseudo-element
      'before:absolute before:rounded-full before:transition-opacity before:opacity-0',
      'before:bg-current',
      'group-hover/switch:before:opacity-[0.08]',
      'group-data-[disabled]/switch:before:opacity-0',
    ],
  },
  variants: {
    size: {
      small: {
        root: 'w-[36px] h-[20px] p-[1.5px]',
        thumb: ['size-[14px]', 'data-[checked]:translate-x-[16px]', 'before:-inset-[7px]'],
      },
      medium: {
        root: 'w-[48px] h-[28px] p-[2.5px]',
        thumb: ['size-[20px]', 'data-[checked]:translate-x-[20px]', 'before:-inset-[9px]'],
      },
    },
    color: {
      default: {},
      primary: {},
      secondary: {},
      error: {},
      warning: {},
      info: {},
      success: {},
    },
    accent: {
      custom: {},
    },
    disabled: {
      true: {
        root: 'opacity-50',
      },
    },
  },
  compoundVariants: [
    {
      color: 'default',
      className: {
        root: [
          'data-[checked]:border-components-switch-knobFillEnabled',
          'data-[checked]:hover:text-text-hover',
        ],
        thumb: 'data-[checked]:bg-components-switch-knobFillEnabled',
      },
    },
    {
      color: 'primary',
      className: {
        root: ['data-[checked]:border-primary-main', 'data-[checked]:hover:bg-primary-main/10'],
        thumb: 'data-[checked]:bg-primary-main',
      },
    },
    {
      color: 'secondary',
      className: {
        root: ['data-[checked]:border-secondary-dark', 'data-[checked]:hover:bg-secondary-dark/10'],
        thumb: 'data-[checked]:bg-secondary-light',
      },
    },
    {
      color: 'error',
      className: {
        root: ['data-[checked]:border-error-main', 'data-[checked]:hover:bg-error-main/10'],
        thumb: 'data-[checked]:bg-error-main',
      },
    },
    {
      color: 'warning',
      className: {
        root: ['data-[checked]:border-warning-main', 'data-[checked]:hover:bg-warning-main/10'],
        thumb: 'data-[checked]:bg-warning-main',
      },
    },
    {
      color: 'info',
      className: {
        root: ['data-[checked]:border-info-main', 'data-[checked]:hover:bg-info-main/10'],
        thumb: 'data-[checked]:bg-info-main',
      },
    },
    {
      color: 'success',
      className: {
        root: ['data-[checked]:border-success-main', 'data-[checked]:hover:bg-success-main/10'],
        thumb: 'data-[checked]:bg-success-main',
      },
    },
    {
      accent: 'custom',
      className: {
        root: [
          'data-[unchecked]:border-transparent data-[unchecked]:bg-white/[0.18]',
          'data-[checked]:border-[rgba(var(--accent-rgb,170,251,178),var(--accent-border-a,0.25))] data-[checked]:bg-[rgba(var(--accent-rgb,170,251,178),var(--accent-bg-a,0.1))]',
          'data-[focus-visible]:outline-[color:var(--accent-solid,#aafbb2)]',
        ],
        thumb: 'data-[unchecked]:bg-white data-[checked]:bg-[color:var(--accent-solid,#aafbb2)]',
      },
    },
  ],
  defaultVariants: {
    size: 'medium',
    color: 'default',
    disabled: false,
  },
})
